module.exports = __webpack_public_path__ + "static/media/Program-real-life.a4aedc98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fina-vaterpolo/Program-real-life.jpg
// module id = 414
// module chunks = 0